import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { useTracking } from "react-tracking";
import { startRegisterTrackingHistory } from "../../app/actions/trackingHistoryActions";
import AdminGroupConcernRoutes from "./AdminGroupConcernRoutes";

const AdminGroupConcernRootScreen = () => {
  const dispatch = useDispatch();
  const { user } = useSelector((state) => state.auth);

  const { Track } = useTracking(
    {
      module: "Administration Group Concern",
      page: "Admin Group Concern Screen",
      user_id: user.user_id,
      user_name: user.user_name,
      
    },
    {
      dispatch: (data) => {

        dispatch(startRegisterTrackingHistory(data));
        
      },
    }
  );
  return (
    <div>
      <Track>
        <AdminGroupConcernRoutes />
      </Track>
    </div>
  );
};

export default AdminGroupConcernRootScreen;
